import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var SvgRsProfilePlaceholderM = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.38,
        d: "M18 0c9.941 0 18 8.059 18 18 0 2.779-.63 5.41-1.754 7.76a6 6 0 1 0-8.485 8.486A17.9 17.9 0 0 1 18 36C8.059 36 0 27.941 0 18S8.059 0 18 0"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        d: "M18.635 7.54a5.743 5.743 0 0 1 5.743 5.742v3.214c0 1.665-.71 3.163-1.844 4.21-1.108 1.026-1.065 2.79.109 3.74a4.7 4.7 0 0 0 1.353.764c.525.19 1.088.406 1.666.645A5.99 5.99 0 0 0 24 30c0 .997.243 1.937.673 2.764A16.1 16.1 0 0 1 18 34.2c-4.824 0-9.153-2.11-12.12-5.456a.4.4 0 0 1 .064-.585c1.767-1.246 4.162-2.26 6.06-2.949.5-.181.956-.441 1.354-.764 1.172-.95 1.216-2.714.108-3.739a5.72 5.72 0 0 1-1.844-4.211v-3.214a5.743 5.743 0 0 1 5.743-5.743z"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        fillOpacity: 0.06,
        fillRule: "nonzero",
        d: "M18 0c9.83 0 17.82 7.88 17.997 17.67L36 18l-.003.33a17.9 17.9 0 0 1-1.751 7.43 6 6 0 0 0-.793-.668 16.9 16.9 0 0 0 1.544-6.769L35 18l-.003-.323C34.825 8.437 27.281 1 18 1 8.611 1 1 8.611 1 18s7.611 17 17 17c2.532 0 4.934-.553 7.093-1.546q.3.424.668.792A17.9 17.9 0 0 1 18 36C8.059 36 0 27.941 0 18S8.059 0 18 0"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var SvgRsProfilePlaceholderM$1 = SvgRsProfilePlaceholderM;

export { SvgRsProfilePlaceholderM$1 as default };
